module.exports = __webpack_public_path__ + "media/images/flags/16/Iraq-6048054c7e421381573092bc997e2fea.png";